"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorsStep = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const common_1 = require("../../../common");
const OperatorsBundle_1 = tslib_1.__importDefault(require("./OperatorsBundle"));
const OperatorsSelect_1 = tslib_1.__importDefault(require("./OperatorsSelect"));
const BundleService_1 = tslib_1.__importDefault(require("../../services/BundleService"));
const hooks_1 = require("../../hooks");
const OperatorsStep = ({ cluster }) => {
    const { addAlert } = (0, common_1.useAlerts)();
    const [bundlesLoading, setBundlesLoading] = react_1.default.useState(true);
    const [bundles, setBundles] = react_1.default.useState([]);
    const { preflightRequirements, isLoading } = (0, hooks_1.useClusterPreflightRequirements)(cluster.id);
    react_1.default.useEffect(() => {
        const fetchBundles = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                const fetchedBundles = yield BundleService_1.default.listBundles();
                setBundles(fetchedBundles);
            }
            catch (error) {
                (0, common_1.handleApiError)(error, () => addAlert({
                    title: 'Failed to fetch operator bundles',
                    message: (0, common_1.getApiErrorMessage)(error),
                }));
            }
            finally {
                setBundlesLoading(false);
            }
        });
        void fetchBundles();
    }, [addAlert]);
    if (isLoading || bundlesLoading) {
        return react_1.default.createElement(common_1.LoadingState, null);
    }
    return (react_1.default.createElement(react_core_1.Stack, { hasGutter: true, "data-testid": 'operators-page' },
        react_1.default.createElement(react_core_1.StackItem, null,
            react_1.default.createElement(common_1.ClusterWizardStepHeader, null, "Operators")),
        react_1.default.createElement(react_core_1.StackItem, null,
            react_1.default.createElement(OperatorsBundle_1.default, { bundles: bundles, preflightRequirements: preflightRequirements })),
        react_1.default.createElement(react_core_1.StackItem, null,
            react_1.default.createElement(OperatorsSelect_1.default, { bundles: bundles, cluster: cluster, preflightRequirements: preflightRequirements }))));
};
exports.OperatorsStep = OperatorsStep;
//# sourceMappingURL=OperatorsStep.js.map